import * as React from "react"
import { endOfWeek } from "date-fns"
import { Alert, Box, Grid } from "@mui/material"
import { disabledAfter } from "@ui-seeker/core"

import { CATALOGUE_ROUTES } from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import { CatalogueDetailsIsEmpty } from "./@signals"
import CatalogueGeneralFilters from "./Filters"
import CatalogueDetailsFormDrawer from "./Form"
import CatalogueDetailsPriceEvolutionChart from "./PriceEvolutionChart"
import CatalogueDetailsTable from "./Table"
import { isSystemBusy } from "../../../@signals"


export default function CatalogueDetailsPage() {
    const endOfSelectedWeek = endOfWeek(new Date(), { weekStartsOn: 1 })

    const props = {
        head: `DIP Insight | ${CATALOGUE_ROUTES.TITLE}`,
        title: CATALOGUE_ROUTES.DETAILS_TITLE,
        subtitle: CATALOGUE_ROUTES.DETAILS_SUBTITLE,
        isEmpty: CatalogueDetailsIsEmpty.value,
        filters: <CatalogueGeneralFilters />,
        hasErrors: isSystemBusy.value,
        tourPageKey: "catalogueDetails",
        actionProps: {
            dateRangeProps: {
                hoverRange: "week",
                shouldDisableDate: disabledAfter(endOfSelectedWeek)
            }
        }
    }

    return <PageWrapper {...props}>
        <Grid container spacing={4}>
            <Grid item xs={12}>
                <Alert severity="warning" sx={{ mb: 1 }}>
                    <Box>The information displayed in this section is only for Mondays.</Box>
                </Alert>
            </Grid>
            <Grid item xs={12} data-tour="catalogue-details-table">
                <CatalogueDetailsTable />
                <CatalogueDetailsFormDrawer />
            </Grid>

            <Grid item xs={12}>
                <CatalogueDetailsPriceEvolutionChart />
            </Grid>
        </Grid>
    </PageWrapper>
}